import { ProductType } from '../../types/Products';

export const QuantityThresholds = {
    [ProductType.nails]: 100,
    [ProductType.shoes]: 20,
};
